import React, { useContext } from 'react';
import useTravelExpenseService from '../../../app/services/hooks/useTravelExpenseService';
import ActiveControl from '../../../components/ActiveControl';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';

interface Props {
    TravelExpenseId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const TravelExpenseSwitchChange = ({ TravelExpenseId, checkValue, callbackSuccess }: Props) => {
    const [checked, setChecked] = React.useState<boolean>(checkValue);
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const { activeTravelExpense, fetchingActiveTravelExpenses } = useTravelExpenseService();

    const active = (value: boolean) => {
        setChecked(value);

        activeTravelExpense(TravelExpenseId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={TravelExpenseId} callback={active} />;
};

export default TravelExpenseSwitchChange;
